import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormGroup, Glyphicon } from 'react-bootstrap';

import { Icon } from '../../atoms/Icon/Icon';
import FieldLabel from '../../atoms/FieldLabel/FieldLabel';
import InfoTooltip from '../../molecules/InfoTooltip/InfoTooltip';

const LabelledInput = ({
  label, disableTooltip, tooltipID, tooltip, valid, error, children, validationPosition, controlId,
}) => {
  const invalid = !valid || error;
  const errorMessage = error || `Your ${label} is required`;
  return (
    <FormGroup className={classNames('LabelledInput', invalid && 'has-error has-feedback')} controlId={controlId}>
      <FieldLabel label={label} />
      <InfoTooltip tooltipID={tooltipID} content={tooltip} disabled={disableTooltip} />
      {invalid && validationPosition === 'top' && <span className="error-message">{errorMessage}</span>}
      {React.Children.toArray(children).map(child => React.cloneElement(child, { 'aria-label': label }))}
      {invalid && validationPosition === 'top' && (
        <Glyphicon className="form-control-feedback" glyph="exclamation-sign" />
      )}
      {invalid && validationPosition === 'bottom' && (
        <div className="LabelledInput_error_wrapper">
          <Icon glyph="exclamation-sign" />
          <span className="LabelledInput_label">{errorMessage}</span>
        </div>
      )}
    </FormGroup>
  );
};

LabelledInput.propTypes = {
  /** Label text */
  label: PropTypes.string,
  /** Controls if tooltip will be shown */
  disableTooltip: PropTypes.bool,
  /** Tooltip id */
  tooltipID: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /** Tooltip content */
  tooltip: PropTypes.any,
  /** Wrapped input component */
  children: PropTypes.any.isRequired,
  /** Display validation warning */
  valid: PropTypes.bool,
  /** Where to display validation error messages */
  validationPosition: PropTypes.oneOf(['bottom', 'top']),
  error: PropTypes.string,
  /** Place coresponding ID on the child */
  controlId: PropTypes.string.isRequired,
};

LabelledInput.defaultProps = {
  label: '',
  validationPosition: 'top',
  disableTooltip: false,
  tooltipID: '',
  tooltip: null,
  valid: true,
  error: '',
};

export default LabelledInput;
